<template>
  <div class="report-result">
    <NavBar class="nav" :title="$route.query.title || $t('result.工单')" :goBack="onClickLeft" />
    <div class="content">
      <div class="infos">
        <van-icon name="checked" />
        <span class="tip">{{ $t('result.工单创建成功') }}</span>
        <!-- <span class="text">工单提交成功后的提醒，后续后台可配置</span> -->
      </div>
      <div class="btns">
        <van-button type="primary" style="margin-right: 10px" @click="goRoute(1)">{{ $t('result.返回首页') }}</van-button>
        <van-button type="primary" @click="goRoute(2)">{{ $t('result.查看工单') }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ReportResult',
    data () {
      return {};
    },
    methods: {
      onClickLeft () {
        this.$router.back();
      },
      goRoute (index) {
        if (index === 1) {
          this.$router.push({
            name: 'UserCenter'
          });
        } else {
          const id = this.$route.query.id;
          this.$router.push({
            name: 'ReportRecord',
            query: {
              type: 0,
              id
            }
          });
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  .report-result {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #f1f1f1;
    .nav {
      flex: 0 0 auto;
    }
    .content {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 30px;
      box-sizing: border-box;
      .infos {
        display: flex;
        flex-direction: column;
        align-items: center;
        line-height: 28px;
        i {
          margin-bottom: 30px;
          color: #2ADE8A;
          font-size: 70px;
        }
        .tip {
          margin-bottom: 8px;
          color: @fontColor;
          font-size: 15px;
          line-height: 15px;
        }
        .text {
          color: #A9A9A9;
          font-size: 12px;
          line-height: 12px;
        }
      }
      .btns {
        display: flex;
        align-items: center;
        margin-top: 60px;
        button {
          width: 132px;
          height: 40px;
          font-size: 16px;
        }
      }
    }
  }
</style>